import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import LiteDashboard from './LiteDashboard';
import DashboardNew from '../DashboardNew';

const LITE_MODE_STORAGE_KEY = 'vendor_dashboard_mode';

const DashboardController = () => {
  const { user, isAdmin } = useAuth();
  const [viewMode, setViewMode] = useState(null); // 'lite' | 'pro' | null (loading)

  useEffect(() => {
    // Don't apply lite mode logic for admins
    if (isAdmin()) {
      setViewMode('pro');
      return;
    }

    // Check localStorage for saved preference first
    const savedMode = localStorage.getItem(LITE_MODE_STORAGE_KEY);
    if (savedMode && ['lite', 'pro'].includes(savedMode)) {
      setViewMode(savedMode);
      return;
    }

    // Smart detection based on device and user preference
    const isMobile = window.innerWidth < 768;
    
    // Auto-default to Lite Mode for:
    // 1. All mobile users (any vendor on mobile)
    // 2. Users who explicitly chose lite mode before
    // Lite Mode is now available to ALL vendors, not just first-time entrepreneurs
    if (isMobile) {
      setViewMode('lite');
    } else {
      setViewMode('pro');
    }
  }, [user, isAdmin]);

  const handleToggleMode = () => {
    const newMode = viewMode === 'lite' ? 'pro' : 'lite';
    setViewMode(newMode);
    // Persist preference
    localStorage.setItem(LITE_MODE_STORAGE_KEY, newMode);
  };

  // Show loading while determining mode
  if (viewMode === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
      </div>
    );
  }

  // Admins always see Pro mode (DashboardNew)
  if (isAdmin()) {
    return <DashboardNew />;
  }

  // Vendors see based on mode preference
  return viewMode === 'lite' 
    ? <LiteDashboard onToggleMode={handleToggleMode} /> 
    : <DashboardNew onToggleLiteMode={handleToggleMode} />;
};

export default DashboardController;
